import {
  Button,
  IconButton,
  Table,
  TableContainer,
  TableRow,
  Typography,
  styled,
} from "@mui/material";

export const StyledlookUpHeading = styled(Typography)({
  color: "var(--Medium-Green, var(--color-brand-Green-Medium, #7CBA25))",
  fontFamily: "Calibri",
  fontSize: 48,
  fontWeight: 300,
  letterSpacing: 0.72,
});

export const StyledLookUpIcon = styled("img")({
  width: 45,
  height: 45,
  flexShrink: 0,
  margin: "7px 22px 7px 22px",
});
export const StyledTable = styled(Table)({
  minWidth: 700,
});
export const StyledTableContainer = styled(TableContainer)({
  maxHeight: 500,
});

export const StyledTableHeaderRow = styled(TableRow)({
  borderBottom: 2.5,
  borderColor: "white",
});

export const StyledSortedIcon = styled("img")({
  marginLeft: "8px",
  cursor: "pointer",
  height:"19px",
   width:"15px"
});

export const StyledTableDataRow = styled(TableRow)({
  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
  borderBottom: 0.55,
  borderTop: 0.55,
  borderColor: "white",
});
export const StyledEditActionButton = styled(Button)({
  background: "var(--color-brand-Green-Medium, #7CBA25)",
  width: 60,
  height: 30,
  borderRadius: 2,
  fontSize: 15,
  "&:hover": {
    background: "var(--color-brand-Green-Medium, #7CBA25)",
  },
});

export const StyledDeleteActionIconButton = styled(IconButton)({
    background: "#E52B24",
    width: 30,
    height: 30,
    marginLeft: 20,
  });

  export const StyledDeleteIcon = styled("img")({
    width: 30,
    height: 30,
  });

  export const StyledCloseButton = styled(Button)({
    background: "var(--color-brand-Green-Medium, #7CBA25)",
              borderRadius: 1.5,
              fontSize: 15,
              "&:hover": {
                background: "var(--color-brand-Green-Medium, #7CBA25)",
              },
  });

  export const StyledError = styled("h1")(() => ({
    color: "var(--Warning-Red, #E52B24)",
    top: 80,
    bottom: 900,
    height: 39,
    width: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Calibri",
    fontSize: 22,
    fontWeight: 400,
    textAlign: "center",
    lineHeight: "normal",
    fontStyle: "normal",
    paddingTop:30
  }));


